import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { Theme } from '@cian/ui-kit';
import * as styles from './ArrowControls.css';
import { Arrow } from './parts/Arrow';
import { Layout } from '../../../Layout';

interface IArrowControlsProps {
  clickHandler?(direction: TDirection): void;
  galleryControl?: React.ReactNode;
  showArrows?: boolean;
}

export const ArrowControls: React.FC<IArrowControlsProps> = props => {
  const { clickHandler, galleryControl, showArrows = true } = props;

  return (
    <div className={styles['container']}>
      <Layout>
        <div className={styles['wrapper']}>
          <Theme theme="onOverlay" displayContents={true}>
            {showArrows && <Arrow direction={-1} clickHandler={clickHandler} />}
            {showArrows && <Arrow direction={1} clickHandler={clickHandler} />}
          </Theme>
          {galleryControl && <div className={styles['gallery']}>{galleryControl}</div>}
        </div>
      </Layout>
    </div>
  );
};
